import Vue from 'vue';
import Vuex from 'vuex';
import user from '@/store/modules/user';
import loading from '@/store/modules/loading';
import reservation from '@/store/modules/reservation';
import chapter from '@/store/modules/chapter';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    chapter,
    reservation,
    loading,
    user
  }
});
